import React from 'react'

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://drive.google.com/file/d/1_aZmaw_nZilERsAKjyhIChHcBIUrsSmk/view?usp=drive_link"
        rel="noreferrer"
        target="_blank"
        className="btn"
      >
        View Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Contact Me
      </a>
    </div>
  );
}

export default CTA